import { Grid } from "@material-ui/core";
import { UseFormReturn } from "react-hook-form";
import { DateSelectComponent } from "./common/DateSelectComponent";
import { TextFieldComponent } from "./common/TextFieldComponent";
import { TextFieldWithHelperComponent } from "./common/TextFieldWithHelperComponent";

interface formUtilsProps {
  formUtils: UseFormReturn<any, any>;
}
export const PrescirberDetails = ({ formUtils }: formUtilsProps) => {
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = formUtils;
  return (
    <>
    <Grid container>
        <Grid item xs={12}>
            <TextFieldWithHelperComponent
                label="Qualification/Specialist qualification"
                id="qualification"
                helpText="Qualification/Specialist qualification information is required in the ACT to generate electronic prescription"
                register={register}
                errors={errors}/>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={7}>
          <TextFieldComponent
            label="HPI-I number"
            id="hpiiNumber"
            required
            register={register}
            errors={errors}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1} justifyContent="space-between">
        <Grid item xs={7}>
          <TextFieldComponent
            label="Prescriber number"
            id="prescriberNumber"
            required
            register={register}
            errors={errors}
          />
        </Grid>
      </Grid>
    </>
  );
};
